import React from "react";
import "../Product/Intro.css";
import { useLanguage } from "../LanguageContext";
import {
  FaIndustry,
  FaMoneyBillAlt,
  FaHotel,
  FaHospital,
  FaSchool,
  FaBuilding,
} from "react-icons/fa";

const Intusty3 = () => {
      const { language } = useLanguage();
const industries = [
  {
    icon: <FaIndustry />,
    title: language === "en" ? "Manufacturing" : "อุตสาหกรรมการผลิต",
    description:
      language === "en"
        ? "Modern factories run on more than machines — they rely on data, uptime, and secure integration. Proscope provides manufacturing businesses with scalable infrastructure, industrial-grade networking, and automation support. We help digitize operations, optimize workflows, and ensure continuity through proactive maintenance and monitoring."
        : "โรงงานยุคใหม่พึ่งพามากกว่าแค่เครื่องจักร — แต่ยังรวมถึงข้อมูล ความต่อเนื่อง และความปลอดภัย Proscope ให้บริการโครงสร้างพื้นฐานที่สามารถขยายได้ รองรับระบบอัตโนมัติ พร้อมระบบเครือข่ายที่ออกแบบมาเพื่อสภาพแวดล้อมอุตสาหกรรม ช่วยให้การดำเนินงานเป็นไปอย่างมีประสิทธิภาพและเสถียร",
  },
  {
    icon: <FaMoneyBillAlt />,
    title: language === "en" ? "Finance" : "การเงิน",
    description:
      language === "en"
        ? "Security, compliance, and performance are non-negotiable in the financial sector. Our IT solutions for banks, fintech firms, and financial institutions ensure peace of mind and operational agility — from private cloud setups and endpoint protection to disaster recovery and compliance-ready infrastructure."
        : "ในภาคการเงิน ความปลอดภัยและความสอดคล้องตามข้อกำหนดคือสิ่งที่ไม่อาจมองข้าม เราพัฒนาโซลูชันไอทีสำหรับธนาคาร บริษัทฟินเทค และสถาบันการเงินที่เน้นโครงสร้างพื้นฐานที่ปลอดภัย คลาวด์ส่วนตัว การสำรองข้อมูล และระบบที่พร้อมใช้งานอยู่เสมอ เพื่อความมั่นใจและคล่องตัวในการดำเนินงาน",
  },
  {
    icon: <FaHotel />,
    title: language === "en" ? "Hotel & Hospitality" : "โรงแรมและธุรกิจบริการ",
    description:
      language === "en"
        ? "In hospitality, guest experience is everything. We support hotels, resorts, and service businesses with reliable network infrastructure, fast Wi-Fi, security systems, and smart automation — all designed to reduce downtime and increase guest satisfaction. Whether it’s back-of-house or front-of-house tech, we keep your systems smooth and seamless."
        : "ในธุรกิจบริการ ประสบการณ์ของลูกค้าคือหัวใจสำคัญ เราช่วยสนับสนุนโรงแรม รีสอร์ท และธุรกิจบริการด้วยระบบเครือข่ายที่เสถียร อินเทอร์เน็ตความเร็วสูง ระบบความปลอดภัย และระบบอัตโนมัติอัจฉริยะ เพื่อลดการหยุดชะงักของระบบ และยกระดับความพึงพอใจของผู้เข้าพัก",
  },
  {
    icon: <FaHospital />,
    title: language === "en" ? "Healthcare" : "สาธารณสุข",
    description:
      language === "en"
        ? "Healthcare IT requires precision, privacy, and reliability. We work with hospitals and clinics to implement secure networks, high-availability infrastructure, and systems that protect patient data while enabling real-time collaboration among staff. Our solutions help healthcare providers improve service delivery while staying compliant with data regulations."
        : "ระบบไอทีสำหรับสุขภาพต้องการความแม่นยำ ความปลอดภัย และความเสถียรสูง เราทำงานร่วมกับโรงพยาบาลและคลินิกเพื่อติดตั้งระบบเครือข่ายที่ปลอดภัย โครงสร้างพื้นฐานที่พร้อมใช้งานตลอดเวลา และระบบที่ปกป้องข้อมูลผู้ป่วยอย่างรัดกุม พร้อมสนับสนุนการทำงานร่วมกันแบบเรียลไทม์",
  },
  {
    icon: <FaSchool />,
    title: language === "en" ? "Education" : "การศึกษา",
    description:
      language === "en"
        ? "Education is evolving fast — and so must the technology behind it. Proscope supports universities, schools, and vocational institutions with IT lifecycle solutions: from hybrid learning environments and device management to campus networks and classroom technologies. We help institutions empower students, teachers, and IT teams alike."
        : "การศึกษายุคใหม่เปลี่ยนแปลงอย่างรวดเร็ว — เทคโนโลยีก็ต้องพัฒนาไปพร้อมกัน Proscope ให้บริการแก่มหาวิทยาลัย โรงเรียน และสถาบันอาชีวศึกษา ด้วยโซลูชันแบบครบวงจร ตั้งแต่การเรียนรู้แบบ Hybrid การบริหารจัดการอุปกรณ์ ไปจนถึงเครือข่ายและเทคโนโลยีห้องเรียน เพื่อเสริมพลังให้นักเรียน ครู และฝ่ายไอที",
  },
  {
    icon: <FaBuilding />,
    title:
      language === "en"
        ? "Government & Public Sector"
        : "ภาครัฐและองค์กรสาธารณะ",
    description:
      language === "en"
        ? "Public organizations demand stability, security, and transparency. Proscope offers government agencies modern IT infrastructure, secure cloud options, and long-term maintenance programs. We assist with digital transformation initiatives, data governance, and cross-department collaboration tools — making public services more accessible, efficient, and secure."
        : "องค์กรภาครัฐต้องการระบบที่มีความเสถียร ปลอดภัย และโปร่งใส เรานำเสนอโครงสร้างพื้นฐานไอทียุคใหม่ พร้อมทางเลือกในการใช้คลาวด์อย่างมั่นใจ และบริการดูแลระยะยาว ช่วยผลักดันการเปลี่ยนผ่านสู่ดิจิทัล การบริหารจัดการข้อมูล และระบบทำงานร่วมกันระหว่างหน่วยงาน เพื่อให้บริการภาครัฐมีประสิทธิภาพ เข้าถึงง่าย และปลอดภัยยิ่งขึ้น",
  },
];
  return (
    <>
      <div className="about-partners">
        <div className="industry-container">
          <div className="content">
            <div className="industry-list">
              {industries.map((industry, index) => (
                <div key={index} className="industry-item">
                  <div className="industry-icon">{industry.icon}</div>
                  <h3 className="industry-title">{industry.title}</h3>
                  <p className="industry-description">{industry.description}</p>
                </div>
              ))}
            </div>
            <p className="description">
              {language === "en" ? (
                <>
                  Whether you’re scaling up, modernizing legacy systems, or just
                  starting your digital journey — Proscope has the insight,
                  tools, and heart to walk with you, every step of the way.
                  <br />
                  <br />
                </>
              ) : (
                <>
                  ไม่ว่าคุณจะเริ่มต้นวางระบบไอที ขยายกิจการ หรือปรับปรุงระบบเดิม
                  — Proscope พร้อมเดินเคียงข้างคุณทุกก้าว ด้วยความเข้าใจ
                  เครื่องมือที่ใช่ และหัวใจที่ทุ่มเท
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Intusty3;
